import fieldType from '@/enums/fieldType'
import i18n from '@/plugins/vuei18n'
import _ from 'lodash'
import Vue from 'vue'

const separator = ';'
const nl = '\n'

export default class Csv {
  constructor (schema) {
    this.csv = ''
    this.schema = schema
    this.tables = []
    this.createHeader()
  }

  static printFromString (string, fileName = 'file') {
    let content = 'data:text/csv;charset=utf-8,' + string
    let encodedUri = encodeURI(content)
    var link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', fileName + '.csv')
    document.body.appendChild(link)
    link.click()
  }

  save () {
    return this.constructor.printFromString(this.csv, this.schema.name)
  }

  loadMultipleRecords (records) {
    records.forEach(record => {
      this.loadRecord(record)
    })
  }

  loadRecord (record) {
    var high = 1
    this.tables.forEach(tab => {
      if (record.results[tab.order].value.length > high) {
        high = record.results[tab.order].value.length
      }
    })

    let row = record.id + separator + record.created_by + separator + record.created_at + separator
    let index = 3
    var results = _.cloneDeep(record.results)

    this.schema.fields.forEach(field => {
      if (field.type === fieldType.TABLE) {
        let table = _.find(this.tables, { order: field.order })
        _.assign(table, { startIndex: index, subFields: field['sub-fields'] })
        let firstSubRecord = results[field.order].value.shift()
        field['sub-fields'].forEach(subField => {
          if (typeof firstSubRecord !== 'undefined' && firstSubRecord.hasOwnProperty(subField.order)) {
            row += Vue.filter('field')(firstSubRecord[subField.order].value, subField.type) || ''
          }
          row += separator
          index++
        })
      } else {
        if (results.hasOwnProperty(field.order)) {
          row += Vue.filter('field')(results[field.order].value, field.type) || ''
        }
        row += separator
        index++
      }
    })
    this.csv += row.substr(0, row.length - 1) + nl

    let i = 1
    while (i < high) {
      let subRow = separator + separator + separator
      let subIndex = 3
      while (subIndex < index) {
        let table = this.tables.find(tab => tab.startIndex === subIndex)
        if (table) {
          let subRecord = results[table.order].value.shift()
          table.subFields.forEach(subField => {
            if (typeof subRecord !== 'undefined' && subRecord.hasOwnProperty(subField.order)) {
              subRow += Vue.filter('field')(subRecord[subField.order].value, subField.type) || ''
            }
            subRow += separator
            subIndex++
          })
        } else {
          subRow += separator
          subIndex++
        }
      }
      this.csv += subRow.substr(0, subRow.length - 1) + nl
      i++
    }
  }

  createHeader () {
    let header = i18n.t('base.id') + separator + i18n.t('form.author') + separator + i18n.t('form.created-at') + separator
    this.schema.fields.forEach(field => {
      if (field.type === fieldType.TABLE) {
        this.tables.push({ order: field.order })
        let tableName = field.name
        field['sub-fields'].forEach(subField => {
          header += tableName + ' - ' + subField.name + separator
        })
      } else {
        header += field.name + separator
      }
    })
    this.csv = header.substr(0, header.length - 1) + nl
  }
}
